import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { HotelSortingValues } from '../constants';

// Hook
const useHotelSortingValues = (tripId) => {
  const hotelSearchState = useSelector((store) => store.hotel.hotelSearches[tripId]);
  const responses = useSelector((state) => state.hotel.hotelSearchResponses);
  const [sortingValues, setSortingValues] = useState(HotelSortingValues);

  useEffect(() => {
    if (hotelSearchState && responses[hotelSearchState.queryString]) {
      const { isSelectedAddress } = responses[hotelSearchState.queryString];
      const sortingItems = isSelectedAddress ? HotelSortingValues : HotelSortingValues.slice(0, -1);
      setSortingValues(sortingItems);
    }
  }, [responses, hotelSearchState]);

  return sortingValues;
};

export default useHotelSortingValues;
